<template>
  <div class="container section">
    <div class="row heading">
      <div class="col">
        <h2>Account Statement Matches</h2>
      </div>
    </div>
    <div class="row table-head" >
      <div class="col">Carrier Account Name</div>
      <div class="col">Carrier Account Number</div>
      <div class="col">&nbsp;</div>
    </div>

    <div class="row lined" v-for="m, i in accountStatementMatches" :key="m.accountStatementMatch_id">
      <div class="col-5">
        {{m.carrier_account_name}}
      </div>
      <div class="col-5">
        {{m.carrier_account_number}}
      </div>
      <div class="col-2 text-right">
        <dropdown-confirmation
          name="saveReport"
          size="sm"
          direction="right"
          triggerBtnClass="btn-delete"
          triggerBtnHtml='<i class="fa fa-trash"></i>'
          confirmBtnClass="btn-danger"
          confirmBtnHtml='<i class="fa fa-remove"></i>&nbsp;&nbsp;Delete'
          @confirm="deleteMatch(m)"
        ></dropdown-confirmation>
      </div>
    </div>

  </div>
</template>
<script type="text/babel">
  import DropdownConfirmation from '../assets/DropdownConfirmation.vue';
  export default {
    name: 'AccountStatementMatches',
    data: function(){
      return {
        params: {
          data: {
            account_id: ''
          }
        }
      }
    },
    created(){
      this.params.data.account_id = this.$route.params.account_id;
    },
    computed:{},
    components:{
      DropdownConfirmation
    },

    methods:{
      deleteMatch(m){
        this.$emit( 'accountStatementMatchDelete', m );
      },
    },
    props:{
      details: {
        type: Object
      },
      accountStatementMatches:{
        type: Array
      }
    }

  }

</script>




// WEBPACK FOOTER //
// AccountStatementMatches.vue?771d9a8a